export enum ZendeskStatusCodes {
  CREATED = 201,
  BAD_REQUEST = 400,
}
